var map = {
  "./ADMINISTRATIVO.svg": "626900",
  "./ANALISE.svg": "663743",
  "./APAC.svg": "358367",
  "./BUSCA_ATIVA.svg": "186200",
  "./CONECTA.svg": "118257",
  "./EEG.svg": "619293",
  "./ELETROCARDIOGRAFIA.svg": "489447",
  "./ESPIROMETRIA.svg": "656634",
  "./ESTOMATO.svg": "735886",
  "./EXAMES.svg": "361709",
  "./GESTAOPACS.svg": "460874",
  "./HELPDESK.svg": "588278",
  "./MENSAGENS.svg": "808997",
  "./OAUTH2.svg": "730009",
  "./OXIGENOTERAPIA.svg": "531637",
  "./POLISSONOGRAFIA.svg": "597414",
  "./RSE.svg": "821182",
  "./TELEATENDIMENTO.svg": "473002",
  "./TELECONSULTORIAS.svg": "260176",
  "./TELEDERMATO.svg": "799628",
  "./TELEEDUCACAO.svg": "346439",
  "./TFD.svg": "318206",
  "./TFDPASSAGENS.svg": "246047"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 278445;
